import React, { useEffect, useState } from "react"
import webify from "../util/webify"
import {
  BasicFilterState,
  allConfirmedAreTrue,
  allPendingAreTrue,
  toggleConfirmedFilters,
  togglePendingFilters,
  defaultBasicFilters,
  toQuery,
  toggleBooleanFilter,
} from "../models/FilterState"
import { getFilteredData } from "../util/getFilteredData"
import FilterTabs from "./FilterTabs"
import ColumnFilters from "./ColumnFilters"

interface Counts {
  confirmedAndCurrentOnPaymentsExcludingComps: number
  confirmedAndBehindOnPaymentsExcludingComps: number
  confirmedAndComped: number
  confirmedIncludingComps: number
  pendingAndMissingInfo: number
  pendingAndNoDeposit: number
  pendingAndPartialDeposit: number
  pending: number
  onWaitlist: number
  cancelled: number
}

interface BasicFiltersProps {
  counts: Counts
  initialFilters: BasicFilterState
  showCustom?: boolean
  showColumnFilters?: boolean
  questionnaires: any[]
}

const BasicFilters = (props: BasicFiltersProps) => {
  let { counts, initialFilters, showCustom, showColumnFilters, questionnaires } = props

  let [filters, setFilters] = useState(toQuery(initialFilters) === "" ? defaultBasicFilters() : initialFilters)

  useEffect(() => {
    getFilteredData(toQuery(filters))
  })

  return (
    <div>
      <div className="filters-component">
        <FilterTabs showCustom={showCustom} />

        <div>
          <label className="header-label" data-role="all-confirmed">
            <input
              type="checkbox"
              checked={allConfirmedAreTrue(filters)}
              onChange={() => setFilters(toggleConfirmedFilters(filters))}
            />
            Confirmed ({counts.confirmedIncludingComps})
          </label>
          <p>Passengers who have paid the deposit or had the costs of their trip comped.</p>
          <label className="filter-subheader-label" data-role="confirmed-and-current">
            <input
              type="checkbox"
              checked={filters.confirmedAndCurrentOnPayments === true}
              onChange={() => setFilters(toggleBooleanFilter(filters, "confirmedAndCurrentOnPayments"))}
            />
            Current on Payments ({counts.confirmedAndCurrentOnPaymentsExcludingComps})
          </label>
          <label className="filter-subheader-label" data-role="confirmed-and-behind">
            <input
              type="checkbox"
              checked={filters.confirmedAndBehindOnPayments === true}
              onChange={() => setFilters(toggleBooleanFilter(filters, "confirmedAndBehindOnPayments"))}
            />
            Behind on Payments ({counts.confirmedAndBehindOnPaymentsExcludingComps})
          </label>
          <label className="filter-subheader-label" data-role="confirmed-and-comped">
            <input
              type="checkbox"
              checked={filters.confirmedAndComped === true}
              onChange={() => setFilters(toggleBooleanFilter(filters, "confirmedAndComped"))}
            />
            Comped ({counts.confirmedAndComped})
          </label>
        </div>
        <div>
          <label className="header-label" data-role="all-pending">
            <input
              type="checkbox"
              checked={allPendingAreTrue(filters)}
              onChange={() => setFilters(togglePendingFilters(filters))}
            />
            Pending ({counts.pending})
          </label>
          <p>Passengers missing required information or who have not paid the deposit.</p>
          <label className="filter-subheader-label" data-role="pending-and-missing-info">
            <input
              type="checkbox"
              checked={filters.pendingAndMissingInfo === true}
              onChange={() => setFilters(toggleBooleanFilter(filters, "pendingAndMissingInfo"))}
            />
            Information Missing ({counts.pendingAndMissingInfo})
          </label>
          <label className="filter-subheader-label" data-role="pending-and-no-deposit">
            <input
              type="checkbox"
              checked={filters.pendingAndNoDeposit === true}
              onChange={() => setFilters(toggleBooleanFilter(filters, "pendingAndNoDeposit"))}
            />
            No Payment Made ({counts.pendingAndNoDeposit})
          </label>
          <label className="filter-subheader-label" data-role="pending-and-partial-deposit">
            <input
              type="checkbox"
              checked={filters.pendingAndPartialDeposit === true}
              onChange={() => setFilters(toggleBooleanFilter(filters, "pendingAndPartialDeposit"))}
            />
            Partial Deposit ({counts.pendingAndPartialDeposit})
          </label>
        </div>
        <div>
          <div>
            <label className="header-label" data-role="on-waitlist">
              <input
                type="checkbox"
                checked={filters.onWaitlist}
                onChange={() => setFilters(toggleBooleanFilter(filters, "onWaitlist"))}
              />
              On Waitlist ({counts.onWaitlist})
            </label>
            <p>When registrations exceed a package's capacity, passengers will be placed on the waitlist.</p>
          </div>
          <div className="mt-8">
            <label className="header-label" data-role="cancelled">
              <input
                type="checkbox"
                checked={filters.cancelled}
                onChange={() => setFilters(toggleBooleanFilter(filters, "cancelled"))}
              />
              Cancelled ({counts.cancelled})
            </label>
            <p>List of all passengers that have been removed from the trip.</p>
          </div>
        </div>
      </div>
      {showColumnFilters && (
        <div className="mt-1">
          <ColumnFilters questionnaires={questionnaires} filters={filters} setFilters={setFilters} />
        </div>
      )}
    </div>
  )
}

export default BasicFilters
webify("basic-filters", BasicFilters)
